/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Button } from '@msdyn365-commerce-modules/utilities';
import classNames from 'classnames';
import * as React from 'react';

interface IRequestInvoiceButtonProps {
    innerReference?: React.RefObject<HTMLButtonElement>;
    className: string;
    requestInvoiceButtonLabel: string;
    requestInvoiceSendMessage: string;
    isSubmitting?: boolean;
    isClicked?: boolean;
    onClicked(): void;
}

export const RequestInvoiceButton: React.FC<IRequestInvoiceButtonProps> = ({
    className,
    onClicked,
    requestInvoiceButtonLabel,
    requestInvoiceSendMessage,
    isSubmitting,
    isClicked,
    innerReference
}) => {
    return (
        <div className='msc-invoices-list__button-wrapper'>
            <Button
                className={classNames(
                    'msc-invoices-list__requestInvoiceButton',
                    isSubmitting ? 'is-busy msc-invoices-list__load-more' : ''
                )}
                disabled={isSubmitting}
                onClick={() => {
                    onClicked();
                }}
                innerRef={innerReference}
            >
                {requestInvoiceButtonLabel}
            </Button>
            {isClicked && <span>{requestInvoiceSendMessage}</span>}
        </div>
    );
};
